import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import { MemberStepInStory, storyStep } from '../../utils/constant'
import StoryFinished from './StoryFinished'
import PremiumStoryFinished from './PremiumStoryFinished'
import { isEnableStreaking } from 'utils/helperFunction'
import { saveLastStep, setStep } from '../../redux/actions/storyAction'
import { idValidAccount, isSunday } from '../../utils/utils'
import { INTRODUCTION } from '../../routes/routeConstant'
import { useLocation, useNavigate } from 'react-router-dom'
import { shouldSaveFinishStep } from '../../utils/lockedStoryRedirect'

const Question: React.FC = (props: any) => {
  const { credentials = {}, story, lastStepEnum, membership, storyLevel } = props
  const authToken = localStorage.getItem('authToken')
  const { customFields } = credentials
  const level = customFields?.level || props.credentials?.level
  const { name } = membership || {}
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    setStep(storyStep.Step4)
  }, [])

  useEffect(() => {
    if (shouldSaveFinishStep({ storyId: story.id, level, lastStepEnum, navigationState: location.state })) {
      saveLastStep(MemberStepInStory.FINISH, storyLevel, story.id)
    }
  }, [story.id, level])

  useEffect(() => {
    window.scrollTo(0, 0)
    if (authToken) {
      if (idValidAccount(props.membershiableStreakp?.name) || isSunday()) {
      }
    }
  }, [props])
  const readAgain = () => {
    // debugger

    saveLastStep(MemberStepInStory.INTRODUCTION, storyLevel, story.id)
    navigate(INTRODUCTION)
  }

  const enableStreak = useMemo(() => isEnableStreaking(name), [name])
  return <>{enableStreak ? <PremiumStoryFinished readAgain={readAgain} /> : <StoryFinished readAgain={readAgain} />}</>
}

const mapStateToProps = (state: any) => ({
  membership: state.user.membership,
  credentials: state.user.credentials,
  story: state.story.currentStory,
  storyLevel: state.story.storyLevel,
  lastStepEnum: state.story.lastStepEnum,
})

export default connect(mapStateToProps)(Question)
